'use client';

import React from 'react';
import { classNames } from '@/shared/lib/classnames/classnames';
interface Props {
  onClick: () => void;
  active: boolean;
  children: React.ReactNode;
  disabled?: boolean;
}
export const TabItem: React.FC<Props> = ({
  onClick,
  active,
  disabled = false,
  children
}) => {
  return <button onClick={onClick} className={classNames('whitespace-nowrap rounded-xl px-3 py-1 transition-colors duration-200', {
    'bg-lightBlue text-additionalBlue': active && !disabled,
    'border hover:bg-gray-100 active:bg-gray-200': !active,
    'pointer-events-none opacity-50': disabled
  })} data-sentry-component="TabItem" data-sentry-source-file="TabItem.tsx">
      {children}
    </button>;
};